import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Badge, Card, FormGroup, PopoverBody, UncontrolledPopover } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row
} from "../../../components/Component";
import { SlickArrowLeft, SlickArrowRight } from "../../../components/partials/slick/SlickComponents";
import { loginAxios } from '../../../config/axios.config';
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";


import { ToastContainer, toast } from "react-toastify";
import SizeTable from "./SizeTable";

const CatalogueDetails = ({ match }) => {

  const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));

  const inventoryDetailsUpdated = useSelector((state) => state.profileReducer.inventoryDetailsUpdated);

  const [sizeList, setSizeList] = useState([]);

  const [details, setDetails] = useState({});

  const [itemStatus, setItemStatus] = useState('');

  const getSizes = async (params) => {
    try {
      const { data } = await loginAxios.get(`designers/get_size?id=${params}`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const getSizesCall = useMutation(getSizes, {
    onSettled(data, error) {
      if (data) {
        setSizeList(data.data.list)
      } else if (error) {
        console.log('found ERROR')
      }
    }
  })


  const getProductDetails = async () => {
    try {
      const { data } = await loginAxios.get(`designers/product-details?product_id=${match.params.id}`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const { isFetching, isLoading, error, isSuccess, isError, data, refetch: fetchProductDetails } = useQuery(['getProductDetails'], getProductDetails, {
    // refetchOnMount: false,
    // refetchOnWindowFocus: false,
    onSettled(data, error) {
      if (data) {
        setItemStatus(data?.data?.status);        
        var initData = data.data.products_details;
        setDetails(initData);
        
        if (data?.data?.products_details?.image?.slider?.length > 0) {
          setCurrentSlide(data.data.products_details.image.slider[0])
        }
        getSizesCall.mutate(data?.data?.products_details?.categoryId);
      }
      else if (error) {        
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
    }
  });



  useEffect(() => {

    console.log(inventoryDetailsUpdated);
    fetchProductDetails();

  }, [inventoryDetailsUpdated])


  const updateStatus = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/product-status`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const updateStatusCall = useMutation(updateStatus, {
    onSettled(data, error) {
      if (data) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });

      } else if (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }

      fetchProductDetails();
    }
  })










  const updateCustomization = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/product-customize-size`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const updateCustomizationCall = useMutation(updateCustomization, {
    onSettled(data, error) {
      if (data) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      } else if (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
      fetchProductDetails();
    }
  })




  const slider1 = useRef(null);
  const slider2 = useRef(null);

  const [sliderData, setSliderData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState({});
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);




  const slideChange = (index) => {
    var product = details?.image?.slider[index];
    setCurrentSlide(product);
  };

  const sliderSettings = {
    className: "slider-init row",
    slidesToShow: 2,
    centerMode: false,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      { breakpoint: 3000, settings: { slidesToShow: 4 } },
      { breakpoint: 1540, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  const sliderSettingsDefault = {
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    slide: null,
    responsive: [
      { breakpoint: 1539, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 420, settings: { slidesToShow: 1 } },
    ],
    arrows: false,
    swipeToSlide: true,
    focusOnSelect: true,
    className: "slider-init slider-nav",
  };


  const handleStatusChange = (e) => {
    var params = {
      status: e.target.checked ? 1 : 0,
      product_id: parseInt(match.params.id)
    }
    updateStatusCall.mutate(params)
  }

  const handleCustomizeChange = (e) => {

    console.log('THIS IS FOR OOOoSIZE')
    var params = {
      isCustomizeSize: e.target.checked ? 1 : 0,
      product_id: parseInt(match.params.id)
    }
    updateCustomizationCall.mutate(params)
  }


















  const colorCustomization = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/product-customize-color`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const colorCustomizationCall = useMutation(colorCustomization, {
    onSettled(data, error) {
      if (data) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      } else if (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
      fetchProductDetails();
    }
  })




  const handleCustomizeColor = (e) => {

    console.log('THIS ONE FIRED')
    var params = {
      isCustomizeColor: e.target.checked ? 1 : 0,
      product_id: parseInt(match.params.id)
    }
    colorCustomizationCall.mutate(params)
  }


  return (
    <React.Fragment>
      <Head title="User Details - Regular"></Head>
      <Content>

        {itemStatus != 'no_data_found' ? <>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>Product Details</BlockTitle>
              {/* <BlockDes className="text-soft">
                <p>An example page for product details</p>
              </BlockDes> */}
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`${process.env.PUBLIC_URL}/product-catalogue`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/product-catalogue`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>


        <Block>
          <Card>
            <div className="card-inner">
              <Row className="pb-5">


                <Col lg={6}>
                  <div className="product-gallery mr-xl-1 mr-xxl-5">
                    <Slider
                      asNavFor={nav2}
                      ref={slider1}
                      arrows={false}
                      fade={true}
                      slidesToShow={1}
                      slidesToScroll={1}
                      initialSlide={currentSlide.id}
                      className="slider-init"
                      prevArrow
                    >
                      <div className="slider-item rounded" key={currentSlide.id}>
                        <img src={currentSlide.img} className="w-100" alt="" />
                      </div>
                    </Slider>
                    <Slider
                      asNavFor={nav1}
                      ref={slider2}
                      afterChange={(newIndex) => slideChange(newIndex)}
                      initialSlide={currentSlide.id}
                      {...sliderSettingsDefault}
                    >
                      {details?.image?.slider.map((item) => {
                        return (
                          <div
                            className={`slider-item ${currentSlide.id === item.id ? "slick-current" : ""}`}
                            key={item.id}
                          >
                            <div className="thumb">
                              <img src={item.img} alt="" />
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </Col>

                <Col lg={6}>

                  <div className="product-info mr-xxl-5">
                    <h4 className="product-title">{details.productTitle}</h4>
                    <h4 className="product-price text-primary">
                      {/* ${sliderData.newPrice}{" "} */}
                      <Badge
                        color=""
                        style={{ marginRight: '10px' }}
                      >Product ID: {details.productID}</Badge>
                      <Badge
                        color=""
                      >Designer Code: {details.designerCode}</Badge>
                    </h4>

                    {/* {details.status == 0 &&
                    
                    } */}
                    <Row className="pb-3 pl-2 pt-3 pr-2 mt-3 align-items-center switch-container">

                      <Col lg={6}>
                        <FormGroup>

                          <label className="form-label" htmlFor="site-off">
                            Product Status
                          </label>
                          <Icon name="help" id="productStatusPop"></Icon>
                        </FormGroup>
                      </Col>

                      <Col lg={6} className="aln-right">
                        <FormGroup>
                          <div className="form-control-wrap">
                            <div className="custom-control custom-switch">
                              <input
                                  checked={details.is_product_active}
                                type="checkbox"
                                className="custom-control-input form-control"
                                name="reg-public"
                                id="site-off"
                                onChange={(e) => handleStatusChange(e)}

                                disabled={userLoginDetails.profile_approval_status == "PENDING" ? true : false}
                              />
                              <label className="custom-control-label" htmlFor="site-off">
                                {details.is_product_active ? 'Active' : 'Inactive'}
                              </label>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <table className="table table-bordered mt-3 table-sm">
                      <tbody>
                        <tr>
                          <th scope="row" width={'50%'} >Main Category</th>
                          <td>{details?.main_category}</td>
                        </tr>
                        <tr>
                          <th scope="row" width={'50%'} >Sub Category</th>
                          <td>{details?.sub_category}</td>
                        </tr>
                        <tr>
                          <th scope="row" width={'50%'} >Sub Sub Category</th>
                          <td>{details.sub_sub_category}</td>

                        </tr>
                        <tr>
                          <th scope="row" width={'50%'} >Color</th>
                          <td>{details?.color_name}</td>
                        </tr>
                      </tbody>
                    </table>



                    <Row className="pb-3 pl-2 pt-3 pr-2 mt-3 align-items-center switch-container">
                      <Col lg={6}>
                        <FormGroup>
                          <label className="form-label" htmlFor="customize-opt">
                            Is Size Customizable
                          </label>
                          <Icon name="help" id="isCustomizePop"></Icon>
                          <span className="form-note">Make product customizable</span>
                        </FormGroup>
                      </Col>

                      <Col lg={6} className="aln-right">
                        <FormGroup>
                          <div className="form-control-wrap">
                            <div className="custom-control custom-switch">
                              <input
                                checked={details.isCustomizeSize}
                                type="checkbox"
                                className="custom-control-input form-control"
                                name="customize-opt"
                                id="custom-off"
                                onClick={(e) => handleCustomizeChange(e)}
                                disabled={userLoginDetails.profile_approval_status == "PENDING" ? true : false}
                              />
                              <label className="custom-control-label" htmlFor="custom-off">
                                {details.isCustomizeSize ? 'Yes' : 'No'}
                              </label>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>




                    <Row className="pb-3 pl-2 pt-3 pr-2 mt-3 align-items-center switch-container">
                      <Col lg={6}>
                        <FormGroup>
                          <label className="form-label" htmlFor="customize-color-opt">
                            Is Colour Customizable
                          </label>
                          <Icon name="help" id="isColorCustomizePop"></Icon>
                          <span className="form-note">Make product customizable</span>
                        </FormGroup>
                      </Col>

                      <Col lg={6} className="aln-right">
                        <FormGroup>
                          <div className="form-control-wrap">
                            <div className="custom-control custom-switch">
                              <input
                                checked={details.isCustomizeColor}
                                type="checkbox"
                                className="custom-control-input form-control"
                                name="customize-color-opt"
                                id="custom-color-off"
                                onClick={(e) => handleCustomizeColor(e)}
                                disabled={userLoginDetails.profile_approval_status == "PENDING" ? true : false}
                              />
                              <label className="custom-control-label" htmlFor="custom-color-off">
                                {details.isCustomizeColor ? 'Yes' : 'No'}
                              </label>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>


                  </div>
                </Col>
              </Row>
              <hr className="hr border-light" />
              <SizeTable productId={match.params.id} sizeList={sizeList} poType={details?.po_price_type} inventoryData={details?.product_set_details} designerId={details?.designerId} />
            </div>
          </Card>
        </Block>

        </> : 
        
        
        <BlockHead size="lg" wide="sm">
        <BlockHeadContent>                         
            {/* <BlockTitle tag="h2" className="fw-normal">
                Help Center
            </BlockTitle> */}
            <BlockDes>
                <h3>Product is deleted.</h3>
            </BlockDes>
            <BlockDes className="mt-2">
                <p className="lead">                
                  Please check with Aza Merchandiser
                </p>
            </BlockDes>
        </BlockHeadContent>
    </BlockHead>
        }

      </Content>
      <ToastContainer />


      {details?.status == 0 &&      <UncontrolledPopover trigger="legacy" placement="bottom" target="productStatusPop">
        {/* <PopoverHeader>MTO Stock</PopoverHeader> */}
        <PopoverBody>
          <p className="popover-text">Active – Product will be displayed on Aza website.
            Inactive – Product will not be displayed on Aza website. </p>
        </PopoverBody>
      </UncontrolledPopover>
}

      <UncontrolledPopover trigger="legacy" placement="bottom" target="isCustomizePop">
        {/* <PopoverHeader>MTO Stock</PopoverHeader> */}
        <PopoverBody>
          <p className="popover-text">If a product is customizable as per customer’s requirements, this flag can be marked as “Yes”</p>
        </PopoverBody>
      </UncontrolledPopover>




      <UncontrolledPopover trigger="legacy" placement="bottom" target="isColorCustomizePop">
        {/* <PopoverHeader>MTO Stock</PopoverHeader> */}
        <PopoverBody>
          <p className="popover-text">If color of a product is customizable as per customer’s requirements, this flag can be marked as “Yes”</p>
        </PopoverBody>
      </UncontrolledPopover>


    </React.Fragment>
  );
};
export default CatalogueDetails;
